/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import HeaderTitle from "../../components/includes/HeaderTitle";
import DriverSearch from "../../components/drivers/DriverSearch";
import DriverSearchResult from "../../components/drivers/DriverSearchResult";
import DriverSearchEmptyResult from "../../components/drivers/DriverSearchEmptyResult";

import Paging from "../../components/includes/Paging";
import {
  LoginAfterCheckLogin,
  ChangeDateStringOnlyDate,
  ChangeMobileFormat,
  isNull,
} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//거래처 관리
const DriverList = ({ setMenuType, setMenuItem }) => {
  LoginAfterCheckLogin(0); //로그인 상태 점검
  let { drMode } = useParams();

  //컬럼기본
  let columnList = [
    { Header: "아이디", accessor: "data1", width: 90 },
    { Header: "기사명", accessor: "data2", width: 90 },
    { Header: "차량번호", accessor: "data3", width: 120 },
    { Header: "연락처", accessor: "data4", width: 150 },
    { Header: "이메일", accessor: "data5", width: 180 },
    { Header: "배차담당자", accessor: "data11", width: 100 },
    { Header: "등록일자", accessor: "data6", width: 90 },
    { Header: "탈퇴일자", accessor: "data7", width: 90 },
    { Header: "고유번호", accessor: "data8", width: 20 },
    { Header: "회원번호", accessor: "data9", width: 10 },
    { Header: "선택유무", accessor: "data10", width: 10 },
  ];
  const [varColumnLists, setColumnLists] = useState([]);

  //거래처목록
  const [varDriverLists, setDriverLists] = useState([]);

  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  const [varMaxNumPage, setMaxNumPage] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);

  //검색
  const [varSearchData, setSearchData] = useState({
    sdate: null,
    edate: null,
    searchOption: "all",
    searchString: "",
  });

  //거래처 목록 읽어오기
  const getDriverList = async () => {
    setIsLoading(true);
    const excelSendData = {
      drMode: drMode,
      pageNum: "1",
      pageSize: 30000,
      searchData: varSearchData,
    };

    await axios
      .post(
        `${process.env.REACT_APP_HOST}/admin_get_driver_list`,
        excelSendData
      )
      .then((res) => {
        const datas = res.data;
        console.log(datas);
        if (datas.retvalue === 1) {
          const dataDriver = datas.results;
          let excelArray = [];
          for (var i = 0; i < dataDriver.length; i++) {
            const lineObj = dataDriver[i];
            var newData = {};
            newData["data1"] = lineObj.mem_id;
            newData["data2"] = lineObj.mem_name;
            newData["data3"] = lineObj.dr_carnumb;
            newData["data4"] = ChangeMobileFormat(lineObj.mem_mobile);
            newData["data5"] = isNull(lineObj.mem_email)
              ? ""
              : lineObj.mem_email;
            newData["data6"] = ChangeDateStringOnlyDate(lineObj.mem_rdate);
            newData["data7"] = ChangeDateStringOnlyDate(lineObj.mem_edate);
            newData["data8"] = lineObj.dr_idx;
            newData["data9"] = lineObj.mem_idx;
            newData["data10"] = 0;
            newData["data11"] = lineObj.staff_name;
            excelArray.push(newData);
          }
          setExcelData(excelArray);
        } else {
          setExcelData([]);
          setIsLoading(false);
        }
      });

    const sendData = {
      drMode: drMode,
      pageNum: varPageNum,
      pageSize: varPageSize,
      searchData: varSearchData,
    };
    console.log(sendData);
    await axios
      .post(`${process.env.REACT_APP_HOST}/admin_get_driver_list`, sendData)
      .then((res) => {
        const datas = res.data;
        console.log(datas);
        if (datas.retvalue === 1) {
          setTotalCount(datas.totalcount);
          const dataDriver = datas.results;
          let newArray = [];
          for (var i = 0; i < dataDriver.length; i++) {
            const lineObj = dataDriver[i];
            var newData = {};
            newData["data1"] = lineObj.mem_id;
            newData["data2"] = lineObj.mem_name;
            newData["data3"] = lineObj.dr_carnumb;
            newData["data4"] = ChangeMobileFormat(lineObj.mem_mobile);
            newData["data5"] = isNull(lineObj.mem_email)
              ? ""
              : lineObj.mem_email;
            newData["data6"] = ChangeDateStringOnlyDate(lineObj.mem_rdate);
            newData["data7"] = ChangeDateStringOnlyDate(lineObj.mem_edate);
            newData["data8"] = lineObj.dr_idx;
            newData["data9"] = lineObj.mem_idx;
            newData["data10"] = 0;
            newData["data11"] = lineObj.staff_name;
            newArray.push(newData);
          }
          setDriverLists(newArray);
          setMaxNumPage(datas.totalcount - (varPageNum - 1) * varPageSize);
          setIsLoading(false);
        } else {
          setDriverLists([]);
          setTotalCount(0);
          setIsLoading(false);
        }
      });
  };

  //페이지 정보 변경시
  useEffect(() => {
    setMenuType("DRIVER");
    setMenuItem(Number(drMode) === 0 ? "ExpiredDriverList" : "DriverList");
    setColumnLists(columnList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //페이지 정보 표시 - 최초
  useEffect(() => {
    getDriverList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drMode, varPageNum, varSearchData]);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle
        varMenuTitle="기사관리"
        varPageTitle={Number(drMode) === 0 ? "탈퇴기사 현황" : "기사 현황"}
      />
      <div className="admin-content">
        <DriverSearch
          varTotalCount={varTotalCount}
          varSearchData={varSearchData}
          setSearchData={setSearchData}
        />
        {varDriverLists?.length === 0 ? (
          <DriverSearchEmptyResult varDRMode={Number(drMode)} />
        ) : (
          <DriverSearchResult
            varDRMode={Number(drMode)}
            varColumnLists={varColumnLists}
            varMaxNumPage={varMaxNumPage}
            varDriverLists={varDriverLists}
            setDriverLists={setDriverLists}
            getDriverList={getDriverList}
            excelData={excelData}
          />
        )}
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging
            totalCount={varTotalCount}
            pageSize={varPageSize}
            curPage={varPageNum}
            setPage={setPageNum}
          />
        </div>
      </div>
    </div>
  );
};
export default DriverList;
